export default {
  title: 'POVPRAŠEVANJE',
  flash: {
    title: 'Stopite v stik z nami.',
    body: 'Vas zanima še kaj in razmišljate o poslovnem sodelovanju? Oglasite se nam!'
  }
}